import {
  useAsync
} from "./chunk-FVZAR5OH.mjs";

// src/useCertificateData.ts
var createUseCertificateData = (httpClient) => (filesCategory) => {
  return useAsync(
    async () => {
      const response = await httpClient.get(
        `/files/${filesCategory}`
      );
      return response.data;
    },
    { deps: [filesCategory] }
  );
};
export {
  createUseCertificateData
};
